<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<nz-card>
  <div class="flex flex-col gap-3">
    <div [ngClass]="loading ? 'hidden' : 'block'">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Advanced Search'">

          <div class="flex flex-col sm:flex-row sm:justify-between md:items-end lg:items-end xl:items-center gap-4">

            <div class="flex flex-col lg:flex-row lg:items-end xl:items-center gap-2 lg:gap-0">


              <div class="flex flex-col lg:flex-row lg:items-center">

                <nz-form-item class="flex flex-col xl:flex-row m-0">
                  <nz-form-label class="text-start">Filter by User</nz-form-label>
                  <nz-select [(ngModel)]="filterUser" (ngModelChange)="search()" nzPlaceHolder="Select User"
                             [nzAllowClear]="true">
                    <nz-option *ngFor="let op of userOptions" [nzValue]="op._id"
                               nzLabel="{{ op.user | titlecase }}"></nz-option>
                  </nz-select>
                </nz-form-item>

                <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>

                <nz-form-item class="flex flex-col xl:flex-row m-0">
                  <nz-form-label class="text-start">Filter by Role</nz-form-label>
                  <nz-select [(ngModel)]="filterRole" (ngModelChange)="search()" nzPlaceHolder="Select Role"
                             [nzAllowClear]="true" >
                    <nz-option *ngFor="let op of rolesOptions" [nzValue]="op._id"
                               nzLabel="{{ op.name | titlecase }}"></nz-option>
                  </nz-select>
                </nz-form-item>

                <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>

                <nz-form-item class="flex flex-col xl:flex-row m-0">
                  <nz-form-label class="text-start">Filter by Module</nz-form-label>
                  <nz-select [(ngModel)]="filterModule" (ngModelChange)="search()" nzPlaceHolder="Select Module"
                             [nzAllowClear]="true" >
                    <nz-option *ngFor="let op of moduleOptions" [nzValue]="op.value"
                               nzLabel="{{ op.label | titlecase }}"></nz-option>
                  </nz-select>
                </nz-form-item>
              </div>

            </div>

            <div class="">
              <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                Reset All
              </button>
            </div>

          </div>
        </nz-collapse-panel>
      </nz-collapse>
    </div>

    <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
      <div class="table-obj">
        <nz-table #systemLogTable [nzData]="data" [nzShowSizeChanger]="pageSize.length > 5"
                  [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
                  [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
                  (nzQueryParams)="onTableParamsChange($event)" [nzScroll]="{ x: 'auto', y: '550px' }" nzTableLayout="fixed"
                  nzOuterBordered class="table-wSpace-nowrap">
          <thead>
          <tr>
            <th *ngFor="let colName of skeletonTableColumns">{{colName}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of systemLogTable.data;" class="align-baseline">
            <td>{{ data.createdAt ? (data.createdAt | date: 'dd-MM-y')  + ' | ' + (data.createdAt | date: 'hh:mm:a') : '-' }}</td>
            <td>{{ data.user ? (data.user | titlecase) : '-' }}</td>
            <td>{{ data.role ? (data.role | titlecase) : '-' }}</td>
            <td>{{ data.module ? (data.module | titlecase) : '-' }}</td>
            <td>{{ data.type ? (data.type | titlecase) : '-' }}</td>
            <td>{{ data.message ? data.message : '-' }}</td>
          </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
    </div>
  </div>
</nz-card>
